module.exports = __webpack_public_path__ + "img/logo-vistat.5e6bb1f.png";